import Vue from 'vue';
import Vuex, { Module, MutationTree, ActionTree, GetterTree } from 'vuex';

import { RootState, State } from '@/shared/models/interface/store-viewmodel';
import { Popup } from '@/shared/models/view/popup-viewmodel';
import { Message } from '@/shared/models/view/message-viewmodel';

Vue.use(Vuex);

const namespaced: boolean = true;

const state: RootState = State

const mutations: MutationTree<RootState> = {
    setLabels(state, { labels, type }) {
        Vue.set(state.labels, type, labels)
    },

    setPopupComponent(state, popup: Popup) {
        state.popupComponent = popup;
    },

    setMessage(state, message: Message) {
        state.messages.push(message);
    },

    setErrors(state, errors: []) {
        state.errors = errors;
    },

    clearErrors(state) {
        state.errors = [];
    }
}

const actions: ActionTree<RootState, RootState> = {
}

const getters: GetterTree<RootState, RootState> = {
    label: (state) => (category: string, key: string, value: string, placeholder: string) => {
        if (state.labels[category]) {
            let label = state.labels[category].find(l => l.key === key);
            key = label ? label.value : key;
        }

        if (placeholder && value !== '') {
            return key.replace(placeholder, value);
        }

        return key;
    },

    labelHelp: (state) => (category: string, key: string, value: string, placeholder: string) => {
        if (state.labels[category]) {
            let label = state.labels[category].find(label => {
                return label.key === key;
            });

            key = label ? label.help : key;
        }

        if (value !== '' && placeholder) {
            return key.replace(placeholder, value);
        }

        return key;
    },

    popupData(state) {
        return state.popupComponent;
    },

    message: (state) => (key: string) => {
        let foundMessage = state.messages.find(message => message.key === key);
        return foundMessage ? foundMessage.text : '';
    }
}

export const root: Module<RootState, any> = {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}
